import { AccessConfig, AccessType } from '../../types/user';


export const accessOptionToSortOrder: Record<AccessType, number> = {
  'admin': 14,
  'full': 12,
  'economy': 10,
  'scout': 8,
  'limitedScout': 6,
  'academy': 4,
  'none': 2,
  'custom': 1,
};


export const editAccessOptions: AccessType[] = [
  'full',
  'economy',
  'scout',
  'limitedScout',
  'academy',
  'none',
  'custom',
];


export const editFokusAccessOptions: AccessType[] = [
  'admin',
  'full',
  'economy',
  'scout',
  'limitedScout',
  'academy',
  'none',
  'custom',
];


export const newAccessOptions: AccessType[] = [
  'full',
  'economy',
  'scout',
  'limitedScout',
  'academy',
  'custom',
];


export const defaultAdminAccessConfig: AccessConfig = {
  accessType: 'admin',

  logisticTeamAccess: 'full',
  hasAccessToScouting: true,
  reportAccess: 'full',

  hasAccessToModifyOwnTeam: true,
  hasAccessToViewTeamRoles: true,
  hasAccessToEconomy: true,

  hasAccessToPlanner: true,
  hasAccessToAcademy: true,
  hasAccessToManageFormations: true,
  hasAccessToManageRoles: true,
};


export const defaultFullAccessConfig: AccessConfig = {
  accessType: 'full',

  logisticTeamAccess: 'full',
  hasAccessToScouting: true,
  reportAccess: 'full',

  hasAccessToModifyOwnTeam: true,
  hasAccessToViewTeamRoles: true,
  hasAccessToEconomy: true,

  hasAccessToPlanner: true,
  hasAccessToAcademy: true,
  hasAccessToManageFormations: true,
  hasAccessToManageRoles: true,
};


export const defaultEconomyAccessConfig: AccessConfig = {
  accessType: 'economy',

  logisticTeamAccess: 'none',
  hasAccessToScouting: false,
  reportAccess: 'none',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: true,
  hasAccessToEconomy: true,

  hasAccessToPlanner: false,
  hasAccessToAcademy: false,
  hasAccessToManageFormations: false,
  hasAccessToManageRoles: false,
};


export const defaultScoutAccessConfig: AccessConfig = {
  accessType: 'scout',

  logisticTeamAccess: 'full',
  hasAccessToScouting: true,
  reportAccess: 'full',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: false,
  hasAccessToEconomy: false,

  hasAccessToPlanner: false,
  hasAccessToAcademy: true,
  hasAccessToManageFormations: true,
  hasAccessToManageRoles: true,
};


export const defaultLimitedScoutAccessConfig: AccessConfig = {
  accessType: 'limitedScout',

  logisticTeamAccess: 'personal',
  hasAccessToScouting: true,
  reportAccess: 'personal',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: false,
  hasAccessToEconomy: false,

  hasAccessToPlanner: false,
  hasAccessToAcademy: false,
  hasAccessToManageFormations: false,
  hasAccessToManageRoles: false,
};


export const defaultAcademyAccessConfig: AccessConfig = {
  accessType: 'academy',

  logisticTeamAccess: 'none',
  hasAccessToScouting: true,
  reportAccess: 'academy',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: false,
  hasAccessToEconomy: false,

  hasAccessToPlanner: false,
  hasAccessToAcademy: true,
  hasAccessToManageFormations: true,
  hasAccessToManageRoles: false,
};


export const defaultNoneAccessConfig: AccessConfig = {
  accessType: 'none',

  logisticTeamAccess: 'none',
  hasAccessToScouting: false,
  reportAccess: 'none',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: false,
  hasAccessToEconomy: false,

  hasAccessToPlanner: false,
  hasAccessToAcademy: false,
  hasAccessToManageFormations: false,
  hasAccessToManageRoles: false,
};


export const defaultCustomAccessConfig: AccessConfig = {
  accessType: 'custom',

  logisticTeamAccess: 'none',
  hasAccessToScouting: false,
  reportAccess: 'none',

  hasAccessToModifyOwnTeam: false,
  hasAccessToViewTeamRoles: false,
  hasAccessToEconomy: false,

  hasAccessToPlanner: false,
  hasAccessToAcademy: false,
  hasAccessToManageFormations: false,
  hasAccessToManageRoles: false,
};


export const accessTypeToDefaultAccessConfig: Record<AccessType, AccessConfig> = {
  'admin': defaultAdminAccessConfig,
  'full': defaultFullAccessConfig,
  'economy': defaultEconomyAccessConfig,
  'scout': defaultScoutAccessConfig,
  'limitedScout': defaultLimitedScoutAccessConfig,
  'academy': defaultAcademyAccessConfig,
  'none': defaultNoneAccessConfig,
  'custom': defaultCustomAccessConfig,
};
